import React, { useState, useEffect } from "react";
import "./CreateCertificate.scss";
import InputComponent from "../../../Styles/Form/InputComponent";
import SelectComponent from "../../../Styles/Form/SelectComponent";
import ButtonComponent from "../../../Styles/Form/ButtonComponent";
import axios from "axios";

function CreateCertificate() {
  const [newCertificate, setNewCertificate] = useState({});
  const [carpetId, setcarpetId] = useState(null);

  const getCarpetId = () => {
    axios
      .get("https://carpet.bistatechnology.ir/api/v1/admin/carpet")
      .then((res) => {
        console.log(res.data);
        setcarpetId(res.data);
      })
      .catch((err) => {
        setcarpetId(false);
        alert("دریافت نشد");
        console.log(err);
      });
  };
  const CreateCertificateHandler = () => {
    axios
      .post(
        `https://carpet.bistatechnology.ir/api/v1/admin/certificate`,
        newCertificate
      )
      .then((res) => {
        console.log(res);
        alert("ثبت موفق", "گروه اشخاص جدید با موفقیت ثبت شد");
        newCertificate(null);
      })
      .catch((err) => {
        console.log(err.response.status);
        alert("خطا", "گروه اشخاص ثبت نشد", "error");
      });
  };
  const changeInputHandler = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    setNewCertificate({ ...newCertificate, [name]: value });
  };
  useEffect(() => {
    getCarpetId();
  }, []);
  useEffect(() => {
    carpetId&& console.log("carpetId : ", carpetId);
    console.log("object");

  }, [carpetId]);
  
  
  return (
    <div className="customized-container CreateCertificate">
      <div className="customized-wrapper ">
        <h5 className="title-session">ایجاد شناسنامه </h5>
        <div className="d-flex flex-row flex-wrap">

          {/* <SelectComponent
            lableValue="ایدی فرش"
            name="carpet_id"
            id="carpet_id"
            options={carpetId?.map((carpetId) => {
              return (
                <option key={carpetId.id} value={carpetId.id}>
                selected={carpetId.id}
                </option>
              );
            })}
            onChange={(e) => changeInputHandler(e)}
          /> */}

           <select
            lable="ایدی"
            onChange={(e) => changeInputHandler(e)}
            name="carpet_id"
            id="carpet_id"
          >
            {carpetId?.map((option, index) => (
              <option key={index} value={option.id}>
                {option.id}
              </option>
            ))}
          </select> 

          <InputComponent
            inputName="certificate_number"
            inputId="certificate_number"
            lableValue="شماره شناسنامه"
            onChange={(e) => changeInputHandler(e)}
            inputPlaceholder="..."
          />
          <InputComponent
            inputName="certificate_serial"
            inputId="certificate_serial"
            lableValue="سریال شناسنامه"
            onChange={(e) => changeInputHandler(e)}
            inputPlaceholder="..."
          />
          <InputComponent
            inputName="code"
            inputId="code"
            lableValue="کد فرش:"
            onChange={(e) => changeInputHandler(e)}
            inputPlaceholder="..."
          />
          <InputComponent
            inputName="years_creation"
            inputId="years_creation"
            lableValue="سال ایجاد:"
            onChange={(e) => changeInputHandler(e)}
            inputPlaceholder="2022-10-10"
          />
          <InputComponent
            inputName="creator"
            inputId="creator"
            lableValue="پدیدآورنده:"
            onChange={(e) => changeInputHandler(e)}
            inputPlaceholder="..."
          />
          <InputComponent
            inputName="place_creation"
            inputId="place_creation"
            lableValue="محل ایجاد/بافت:"
            onChange={(e) => changeInputHandler(e)}
            inputPlaceholder="..."
          />
          <InputComponent
            inputName="designer"
            inputId="designer"
            lableValue="طراح:"
            onChange={(e) => changeInputHandler(e)}
            inputPlaceholder="..."
          />
          <InputComponent
            inputName="master_weaver"
            inputId="master_weaver"
            lableValue="استاد بافنده:"
            onChange={(e) => changeInputHandler(e)}
            inputPlaceholder="..."
          />
          <InputComponent
            inputName="weave_method"
            inputId="weave_method"
            lableValue="شیوه بافت"
            onChange={(e) => changeInputHandler(e)}
            inputPlaceholder="..."
          />
          <InputComponent
            inputName="knot_type"
            inputId="knot_type"
            lableValue="نوع گره"
            onChange={(e) => changeInputHandler(e)}
            inputPlaceholder="..."
          />
          <InputComponent
            inputName="pile_material"
            inputId="pile_material"
            lableValue="جنس پرز/گره"
            onChange={(e) => changeInputHandler(e)}
            inputPlaceholder="..."
          />
          <InputComponent
            inputName="warp_material"
            inputId="warp_material"
            lableValue="جنس تار"
            onChange={(e) => changeInputHandler(e)}
            inputPlaceholder="..."
          />
          <InputComponent
            inputName="weft_material"
            inputId="weft_material"
            lableValue="جنس پود"
            onChange={(e) => changeInputHandler(e)}
            inputPlaceholder="..."
          />
          <InputComponent
            inputName="design_type"
            inputId="design_type"
            lableValue="نوع طرح"
            onChange={(e) => changeInputHandler(e)}
            inputPlaceholder="..."
          />
          <InputComponent
            inputName="design_name"
            inputId="design_name"
            lableValue="نام نقشه"
            onChange={(e) => changeInputHandler(e)}
            inputPlaceholder="..."
          />
          <InputComponent
            inputName="ground_color"
            inputId="ground_color"
            lableValue="رنگ متن"
            onChange={(e) => changeInputHandler(e)}
            inputPlaceholder="..."
          />
          <InputComponent
            inputName="border_color"
            inputId="border_color"
            lableValue="رنگ حاشیه"
            onChange={(e) => changeInputHandler(e)}
            inputPlaceholder="..."
          />
          <InputComponent
            inputName="number_color"
            inputId="number_color"
            lableValue="تعداد رنگ"
            onChange={(e) => changeInputHandler(e)}
            inputPlaceholder="..."
          />
          <InputComponent
            inputName="width"
            inputId="width"
            lableValue="عرض به سانتی متر"
            onChange={(e) => changeInputHandler(e)}
            inputPlaceholder="..."
          />
          <InputComponent
            inputName="length"
            inputId="length"
            lableValue="طول به سانتی متر"
            onChange={(e) => changeInputHandler(e)}
            inputPlaceholder="..."
          />
          <InputComponent
            inputName="area"
            inputId="area"
            lableValue="مساحت مترمربع"
            onChange={(e) => changeInputHandler(e)}
            inputPlaceholder="..."
          />
          <InputComponent
            inputName="unit_raj"
            inputId="unit_raj"
            lableValue="مبدا رج به سانتی متر"
            onChange={(e) => changeInputHandler(e)}
            inputPlaceholder="..."
          />
          <InputComponent
            inputName="raj_counter"
            inputId="raj_counter"
            lableValue="رج شمار"
            onChange={(e) => changeInputHandler(e)}
            inputPlaceholder="..."
          />
          <InputComponent
            inputName="density"
            inputId="density"
            lableValue="تراکم در دسی متر مربع"
            onChange={(e) => changeInputHandler(e)}
            inputPlaceholder="..."
          />
          <InputComponent
            inputName="number_knots_width"
            inputId="number_knots_width"
            lableValue="تعداد گره در عرض"
            onChange={(e) => changeInputHandler(e)}
            inputPlaceholder="..."
          />
          <InputComponent
            inputName="number_knot_length"
            inputId="number_knot_length"
            lableValue="تعداد گره در طول"
            onChange={(e) => changeInputHandler(e)}
            inputPlaceholder="..."
          />
          <InputComponent
            inputName="total_number_knot"
            inputId="total_number_knot"
            lableValue="تعداد کل گره"
            onChange={(e) => changeInputHandler(e)}
            inputPlaceholder="..."
          />
          <InputComponent
            inputName="man_hours_creation"
            inputId="man_hours_creation"
            lableValue="نفر ساعت تولید "
            onChange={(e) => changeInputHandler(e)}
            inputPlaceholder="..."
          />
          <InputComponent
            inputName="number_weaver"
            inputId="number_weaver"
            lableValue="تعداد بافنده"
            onChange={(e) => changeInputHandler(e)}
            inputPlaceholder="..."
          />
          <InputComponent
            inputName="duration_creation"
            inputId="duration_creation"
            lableValue="مدت زمان تولید-ماه"
            onChange={(e) => changeInputHandler(e)}
            inputPlaceholder="..."
          />

          <InputComponent
            inputName="weight"
            inputId="weight"
            lableValue="وزن به کیلوگرم"
            onChange={(e) => changeInputHandler(e)}
            inputPlaceholder="..."
          />
          <InputComponent
            inputName="seconder"
            inputId="seconder"
            lableValue="تاییدکننده"
            onChange={(e) => changeInputHandler(e)}
            inputPlaceholder="..."
          />
          <InputComponent
            inputName="description"
            inputId="description"
            lableValue="توضیحات"
            onChange={(e) => changeInputHandler(e)}
            inputPlaceholder="..."
          />
          <InputComponent
            inputName="transaction_code"
            inputId="transaction_code"
            lableValue="کد تراکنش"
            onChange={(e) => changeInputHandler(e)}
            inputPlaceholder="..."
          />
          <InputComponent
            inputName="date"
            inputId="date"
            lableValue="تاریخ"
            onChange={(e) => changeInputHandler(e)}
            inputPlaceholder="..."
          />
          <InputComponent
            inputName="owner_code"
            inputId="owner_code"
            lableValue="کد مالک "
            onChange={(e) => changeInputHandler(e)}
            inputPlaceholder="..."
          />
          <InputComponent
            inputName="owner_name"
            inputId="owner_name"
            lableValue="نام مالک"
            onChange={(e) => changeInputHandler(e)}
            inputPlaceholder="..."
          />
        </div>
        <ButtonComponent
          value="ثبت"
          onClick={() => CreateCertificateHandler()}
        />
      </div>
    </div>
  );
}

export default CreateCertificate;
